import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { searchActors, setSearchParameters } from 'actions/admin/actors';
import { performSearch, mergeSearchParameters } from 'components/adminTable/AdminTableHelper';
import routes from 'routes';
import { getContact, getBusinessOrPrivateName } from 'helpers/ActorHelper';
import contactTypes from 'enums/contactTypes';

import { Link } from 'react-router-dom';
import AdminPage from '../../presentational/AdminPage';
import AdminContentWrapper from '../../presentational/AdminContentWrapper';
import SearchActorsForm from './SearchActorsForm';
import AdminTable from 'components/adminTable/AdminTable';
import Loader from 'common/Loader';
import ShortDateTime from 'common/ShortDateTime';

const columns = [
    {
        title: 'ID',
        id: 'id',
        align: 'right'
    },
    {
        title: 'Name',
        id: 'name',
        render: actor => <Link to={routes.admin.actor.replace(':actorId', actor.id)}>{getBusinessOrPrivateName(actor)}</Link>
    },
    {
        title: 'E-mail',
        id: 'email',
        render: actor => getContact(actor, contactTypes.mainEmail)
    },
    {
        title: 'Organization type',
        id: 'organizationType',
    },
    {
        title: 'Created',
        id: 'createdTime',
        render: actor => <ShortDateTime value={actor.createdTime}/>
    },
];

const Actors = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();

    const searchResult = useSelector(state => state.admin.actors.searchResult);
    const searchParametersFromState = useSelector(state => state.admin.actors.searchParameters);

    const defaultParameters = {
        query: undefined,
        page: 0,
        pageSize: 20,
        sortByColumn: 'createdTime',
        sortDirection: 'desc'
    };

    const search = (parameters) => {
        const searchParameters = mergeSearchParameters(parameters, location, searchParametersFromState, defaultParameters);
        performSearch(performSearchObject, searchParameters);
    };

    const performSearchObject = {
        searchParametersFromState,
        setSearchParametersToState: parameters => dispatch(setSearchParameters(parameters)),
        searchResult,
        search,
        apiCall: parameters => dispatch(searchActors(parameters)),
        location,
        history,
        isInitializedRef: useRef()
    };

    useEffect(() => {
        const searchParameters = mergeSearchParameters({}, location, searchParametersFromState, defaultParameters);
        performSearch(performSearchObject, searchParameters);
    }, []);

    const handleSearchFormSubmit = formValues => {
        search({ ...defaultParameters, ...formValues, page: 0 });
    };

    const handleSort = sortingParameters => {
        search(sortingParameters);
    };

    const handlePageChange = newPage => {
        search({ page: newPage });
    };

    const handlePageChangeSize = newPageSize => {
        search({ page: 0, pageSize: newPageSize });
    };

    return (
        <AdminPage title="Actors">
            <AdminContentWrapper type="listing">

                <SearchActorsForm
                    searchParameters={searchParametersFromState}
                    onSubmit={handleSearchFormSubmit}
                />

                <div>
                    {
                        searchResult.isLoading && <Loader />
                    }
                    {
                        searchResult.items && (
                            <AdminTable
                                isPaged
                                items={searchResult.items}
                                count={searchResult.count}
                                page={searchResult.page}
                                pageSize={searchResult.pageSize}
                                columns={columns}
                                sortByColumn={columns.find(c => c.id === searchParametersFromState.sortByColumn)}
                                sortDirection={searchParametersFromState.sortDirection}
                                onSort={handleSort}
                                onPageChange={handlePageChange}
                                onPageChangeSize={handlePageChangeSize}
                            />
                        )
                    }
                </div>

            </AdminContentWrapper>
        </AdminPage>
    );
};

export default Actors;
